export default __webpack_public_path__ + "static/media/Levis.55723420.jpeg";